// extracted by mini-css-extract-plugin
export default {"swimlane":"swimlane_swimlane__fN6q6"};